var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisible)?_c('div',{attrs:{"id":"tutorial-container"}},[_vm._m(0),_c('p',{on:{"click":_vm.toggleVisibility}},[_vm._v("Cerrar tutorial")])]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"tutorial"}},[_c('iframe',{attrs:{"width":"711","height":"400","src":"https://www.youtube.com/embed/16IpkM7ueWU?rel=0&showinfo=0","frameborder":"0","allowfullscreen":""}})])
}]

export { render, staticRenderFns }